// extracted by mini-css-extract-plugin
export default {"container":"Layout_container__20pG9","content":"Layout_content__F6jMU"};